import { Chip, Box } from "@mui/material";

type Props = {
  children: React.ReactNode;
  style?: React.CSSProperties;
  title: string;
};

export const ImageBox = ({ children, style, title }: Props) => {
  return (
    <Box
      sx={{
        border: "1px solid #ccc",
        borderRadius: "4px",
        position: "relative",
        overflow: "hidden",
        ...style,
        padding: 1,
      }}
    >
      <Box
        sx={{
          height: "2em",
          position: "relative",
        }}
      >
        <Chip
          label={title}
          size="small"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            transform: "translate(8px, 0)",
            zIndex: 1,
            backgroundColor: "secondary.main",
            color: "secondary.contrastText",
          }}
        />
      </Box>
      <Box
        sx={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "calc(100% - 2em)",
          flexGrow: 1,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
